export class PriceListAsImportModel {
  counter: number = 0;
  companyId: number = 0;
  branchId: number = 0;
  priceListCode: number = 0;
  priceListAlterCode: string = "";
  priceListName: string = "";
  priceListDiscount: number = 0;
  priceListObservation: string = "";
  articleCode: number = 0;
  baseValue: number = 0;
  clientValue: number = 0;
  discountValue: number;
  swManual: boolean = false;
  constructor(counter: number = 0,
    companyId: number = 0,
    branchId: number = 0,
    priceListCode: number = 0,
    priceListAlterCode: string = "",
    priceListName: string = "",
    priceListDiscount: number = 0,
    priceListObservation: string = "",
    articleCode: number = 0,
    baseValue: number = 0,
    clientValue: number = 0,
    discountValue: number,
    swManual: boolean = false) {
    this.counter = counter;
    this.companyId = companyId;
    this.branchId = branchId;
    this.priceListCode = priceListCode;
    this.priceListAlterCode = priceListAlterCode;
    this.priceListName = priceListName;
    this.priceListDiscount = priceListDiscount;
    this.priceListObservation = priceListObservation;
    this.articleCode = articleCode;
    this.baseValue = baseValue;
    this.clientValue = clientValue;
    this.discountValue = discountValue;
    this.swManual = swManual;
  }
}